import React, { useState, useEffect, useRef } from 'react';
import { 
  BarChart3, LayoutDashboard, FileText, Database, Map as MapIcon, 
  Bell, CheckCircle2, AlertTriangle, Clock, ChevronRight, ChevronDown,
  User, PlayCircle, Bot, Sparkles, MapPin, Target, ListTodo, Activity, Loader2, Send,
  Landmark, HardHat, TreePine, ShieldAlert, Briefcase, GraduationCap, HeartPulse, LogOut,
  Layers, Megaphone, Settings, BookOpen, AlertCircle, Users
} from 'lucide-react';

// Map icon để render động trong các màn hình Lĩnh vực
const iconMap = {
  FileText, Clock, CheckCircle2, AlertTriangle, Database, Activity, MapPin, 
  ShieldAlert, GraduationCap, HeartPulse, Landmark, HardHat, Briefcase, 
  TreePine, User, Users, Bell, BarChart3, Megaphone, AlertCircle
};

// --- MOCK DATA CÁC NGÀNH/LĨNH VỰC ---
const SECTOR_DATA = {
  docs: {
    title: "Hành chính công & Dịch vụ công",
    kpis: [ 
      { label: "Tổng hồ sơ (Tháng)", value: "3,235", unit: "hồ sơ", subtext: "Đã tiếp nhận", color: "blue", icon: "FileText" }, 
      { label: "Tỷ lệ trực tuyến", value: "99.6%", unit: "toàn trình", subtext: "Vượt chỉ tiêu Tỉnh", color: "emerald", icon: "Activity" }, 
      { label: "Đúng/Trước hạn", value: "99.9%", unit: "đúng hạn", subtext: "Hiệu suất xử lý", color: "emerald", icon: "CheckCircle2" }, 
      { label: "Nguy cơ trễ hạn", value: "7", unit: "hồ sơ", subtext: "Cần đôn đốc khẩn", color: "red", icon: "Clock" } 
    ],
    scenarios: [
      { id: 'hc1', type: 'docs', title: '7 Hồ sơ đất đai gần quá hạn', location: 'Bộ phận 1 Cửa', aiSuggest: 'Phát hiện API giữa phần mềm iOffice và iGate bị treo, không cập nhật kết quả. Đề xuất: Phân công Tổ Công nghệ thông tin (IT) reset lại luồng đồng bộ ngay lập tức.', assignee: 'Tổ Công nghệ thông tin' },
      { id: 'hc2', type: 'docs', title: 'Công dân đánh giá "Không hài lòng"', location: 'Quầy Tư pháp - Hộ tịch', aiSuggest: 'Phản ánh thái độ cán bộ tiếp dân chưa hòa nhã. Đề xuất: Trích xuất camera quầy giao dịch, Trưởng bộ phận 1 cửa làm việc trực tiếp với cán bộ liên quan.', assignee: 'Trưởng bộ phận Một cửa' },
      { id: 'hc3', type: 'docs', title: 'Hồ sơ xin cấp phép kinh doanh bị kẹt', location: 'Bộ phận Kinh tế', aiSuggest: 'Hồ sơ chờ xác minh thực địa quá 3 ngày. Đề xuất: Đôn đốc cán bộ đô thị báo cáo kết quả xác minh ngay trong chiều nay.', assignee: 'Cán bộ Kinh tế - Đô thị' },
      { id: 'hc4', type: 'docs', title: 'Máy bốc số thứ tự tự động báo lỗi', location: 'Sảnh chờ Bộ phận 1 Cửa', aiSuggest: 'Gây ùn ứ cục bộ người dân đến giao dịch. Đề xuất: Giao cán bộ IT kiểm tra phần cứng máy in nhiệt, tạm thời bốc số thủ công.', assignee: 'Tổ Công nghệ thông tin' },
      { id: 'hc5', type: 'docs', title: 'Tăng đột biến hồ sơ xin xác nhận cư trú', location: 'Quầy Công an', aiSuggest: 'Số lượng hồ sơ tăng 200% so với ngày thường. Đề xuất: Tăng cường thêm 1 đồng chí công an trực tại quầy 1 cửa để giảm tải.', assignee: 'Công an Phường' }
    ]
  },
  data: {
    title: "Dữ liệu & Số hóa",
    kpis: [ 
      { label: "Tiến độ số hóa", value: "99.9%", unit: "toàn phường", subtext: "Cập nhật hôm nay", color: "emerald", icon: "Database" }, 
      { label: "Lỗi định dạng", value: "124", unit: "bản ghi", subtext: "Sai CCCD/SĐT", color: "red", icon: "AlertTriangle" }, 
      { label: "Lệch đồng bộ", value: "45", unit: "bản ghi", subtext: "Hệ thống Y tế", color: "amber", icon: "Activity" }, 
      { label: "Thiếu định danh", value: "15", unit: "hồ sơ", subtext: "An sinh xã hội", color: "amber", icon: "User" } 
    ],
    scenarios: [
      { id: 'dl1', type: 'data', title: '124 bản ghi dân cư sai định dạng CCCD/SDT', location: 'Cơ sở dữ liệu Hành chính', aiSuggest: 'Lỗi logic do phần mềm cũ đẩy lên thiếu bước kiểm tra (validate) 12 ký tự. Đề xuất: Xuất danh sách lỗi, giao Tổ công tác Đề án 06 khu vực gọi điện xác minh và làm sạch.', assignee: 'Tổ Đề án 06 & Tư pháp' },
      { id: 'dl2', type: 'data', title: 'Sai lệch 45 số liệu tiêm chủng so với sổ vật lý', location: 'Cổng Dữ liệu Y tế', aiSuggest: 'Phát hiện 45 trẻ đã tiêm nhưng chưa có dữ liệu trên hệ thống số. Đề xuất: Giao Trạm Y tế rà soát lại sổ giấy và nhập liệu bổ sung trước cuối tuần.', assignee: 'Trạm Y tế phường' },
      { id: 'dl3', type: 'data', title: '15 hồ sơ hộ nghèo chưa chuẩn hóa mã định danh', location: 'CSDL An sinh xã hội', aiSuggest: 'Dữ liệu thiếu ảnh hưởng trực tiếp đến việc chi trả trợ cấp qua thẻ ATM. Đề xuất: Cán bộ LĐTBXH xuống tận nhà hỗ trợ công dân cập nhật.', assignee: 'Cán bộ LĐTBXH' },
      { id: 'dl4', type: 'data', title: 'Cảnh báo gián đoạn API liên thông dữ liệu DVC', location: 'Trung tâm Dữ liệu Tỉnh', aiSuggest: 'Hệ thống ghi nhận Downtime 5 phút mất kết nối với Cổng DVC Quốc gia. Đề xuất: Khởi động hệ thống cache dự phòng, báo cáo kỹ thuật Tỉnh.', assignee: 'Tổ Công nghệ thông tin' },
      { id: 'dl5', type: 'data', title: 'Chưa đồng bộ báo cáo Học bạ điện tử (2 trường)', location: 'Khối Trường Tiểu học', aiSuggest: 'Hệ thống GD&ĐT báo cáo thiếu dữ liệu học lực tháng của 2 điểm trường. Đề xuất: Gửi thông báo tự động đôn đốc Ban giám hiệu 2 trường.', assignee: 'Bộ phận Giáo dục' }
    ]
  },
  reports: {
    title: "Phản ánh Hiện trường",
    kpis: [ 
      { label: "Tổng phản ánh", value: "18", unit: "ý kiến", subtext: "Tiếp nhận trong ngày", color: "blue", icon: "Megaphone" }, 
      { label: "Đã xử lý xong", value: "14", unit: "vấn đề", subtext: "Hoàn thành", color: "emerald", icon: "CheckCircle2" }, 
      { label: "Trật tự đô thị", value: "2", unit: "điểm", subtext: "Cần giải tỏa", color: "amber", icon: "HardHat" }, 
      { label: "Môi trường", value: "2", unit: "điểm nóng", subtext: "Cần xử lý khẩn", color: "red", icon: "TreePine" } 
    ],
    scenarios: [
      { id: 'pa1', type: 'reports', title: 'Điểm nóng rác thải tự phát gây ô nhiễm', location: 'Bãi đất trống, Tổ dân phố 3', aiSuggest: 'Nhiều phản ánh của dân về mùi hôi. Đề xuất: Giao Tổ đô thị xuống dọn dẹp, phối hợp Công an trích xuất camera phạt nguội.', assignee: 'Đội Trật tự Đô thị & Môi trường' },
      { id: 'pa2', type: 'reports', title: 'Bơm hút cát trái phép dưới lòng sông', location: 'Đoạn sông qua Tổ 8', aiSuggest: 'Hành vi khai thác khoáng sản trái phép, thay đổi dòng chảy. Đề xuất: Báo cáo nhanh Cảnh sát đường thủy và tổ chức mật phục vây bắt.', assignee: 'Công an Phường & Thủy cảnh' },
      { id: 'pa3', type: 'reports', title: 'Lấn chiếm vỉa hè kinh doanh ăn uống', location: 'Đường Trần Phú, Tổ 1', aiSuggest: 'Quán ăn bày bàn ghế lấn chiếm hết lối đi bộ. Đề xuất: Cán bộ đô thị lập biên bản nhắc nhở, thu giữ vật dụng nếu tái phạm.', assignee: 'Đội Quản lý Trật tự Đô thị' },
      { id: 'pa4', type: 'reports', title: 'Tập kết vật liệu xây dựng chắn ngang ngõ', location: 'Ngõ 22, Tổ 5', aiSuggest: 'Gây ách tắc giao thông trong ngõ nhỏ. Đề xuất: Yêu cầu chủ nhà di dời trong vòng 2 tiếng, nếu không sẽ lập biên bản phạt.', assignee: 'Cán bộ Trật tự Đô thị' },
      { id: 'pa5', type: 'reports', title: 'Hỏng nắp cống thoát nước lộ thiên', location: 'Đầu hẻm 12', aiSuggest: 'Gây nguy hiểm trực tiếp cho xe máy ban đêm. Đề xuất: Rào chắn tạm thời ngay lập tức, báo cáo Xí nghiệp thoát nước khắc phục.', assignee: 'Bộ phận Hạ tầng kỹ thuật' }
    ]
  },
  alerts: {
    title: "Cảnh báo Cần xử lý",
    kpis: [ 
      { label: "Tổng cảnh báo", value: "5", unit: "sự cố", subtext: "Từ hệ thống IOC", color: "blue", icon: "Bell" }, 
      { label: "Khẩn cấp (Đỏ)", value: "2", unit: "vụ việc", subtext: "Cần điều hành ngay", color: "red", icon: "AlertTriangle" }, 
      { label: "Rủi ro (Vàng)", value: "3", unit: "vụ việc", subtext: "Theo dõi sát", color: "amber", icon: "AlertCircle" }, 
      { label: "Đã xử lý (Xanh)", value: "0", unit: "vụ việc", subtext: "Trong ngày", color: "emerald", icon: "CheckCircle2" } 
    ],
    scenarios: [
      { id: 'cb1', type: 'alerts', title: '[Hành chính] 7 Hồ sơ đất đai gần quá hạn', location: 'Bộ phận 1 Cửa', aiSuggest: 'Lỗi phần mềm iGate không đồng bộ. Đề xuất: Yêu cầu bộ phận IT xử lý khẩn cấp trước 17h chiều nay để tránh rớt KPI.', assignee: 'Tổ Công nghệ thông tin' },
      { id: 'cb2', type: 'alerts', title: '[Đô thị] Xây dựng sai phép vượt tầng', location: 'Đường Trần Phú, Tổ 2', aiSuggest: 'Vi phạm nghiêm trọng quy hoạch đô thị. Đề xuất: Lập đoàn kiểm tra, lập biên bản đình chỉ thi công và yêu cầu tháo dỡ.', assignee: 'Đội Quản lý Trật tự Đô thị' },
      { id: 'cb3', type: 'alerts', title: '[Dữ liệu] 124 bản ghi dân cư sai định dạng', location: 'Cơ sở dữ liệu Hành chính', aiSuggest: 'Nguy cơ nghẽn dữ liệu Đề án 06. Đề xuất: Giao Tổ công tác Đề án 06 khu vực rà soát lại sổ giấy đối chiếu.', assignee: 'Tổ Đề án 06' },
      { id: 'cb4', type: 'alerts', title: '[ATGT] Đậu xe chắn ngang hẻm cứu hỏa', location: 'Đầu hẻm 20', aiSuggest: 'Cản trở lưu thông và PCCC. Đề xuất: Thông báo loa tìm chủ xe, nếu không có mặt tiến hành cẩu xe, phạt vi phạm.', assignee: 'Cảnh sát Giao thông' },
      { id: 'cb5', type: 'alerts', title: '[Giáo dục] Ùn tắc giao thông cổng trường', location: 'Trường Tiểu học A', aiSuggest: 'Tính chất lặp lại giờ tan tầm. Đề xuất: Phối hợp Đoàn thanh niên và Công an phường cắm chốt phân luồng từ 16h30.', assignee: 'Công an & Đoàn Thanh niên' }
    ]
  },
  construction: {
    title: "Xây dựng Đô thị",
    kpis: [ 
      { label: "Giấy phép đã cấp", value: "45", unit: "GPXD", subtext: "Cấp mới trong tháng", color: "emerald", icon: "FileText" }, 
      { label: "Đang thi công", value: "12", unit: "công trình", subtext: "Giám sát thường xuyên", color: "blue", icon: "HardHat" }, 
      { label: "Sự cố hạ tầng", value: "3", unit: "sự cố", subtext: "Hỏng cống, sụt lún", color: "amber", icon: "AlertCircle" }, 
      { label: "Vi phạm sai phép", value: "2", unit: "vụ việc", subtext: "Cơi nới, vượt tầng", color: "red", icon: "AlertTriangle" } 
    ],
    scenarios: [
      { id: 'xd1', type: 'construction', title: 'Xây dựng sai phép vượt tầng', location: 'Đường Trần Phú, Tổ 2', aiSuggest: 'Vi phạm nghiêm trọng quy hoạch đô thị. Đề xuất: Lập đoàn kiểm tra, lập biên bản đình chỉ thi công và yêu cầu tháo dỡ phần sai phép.', assignee: 'Đội Quản lý Trật tự Đô thị' },
      { id: 'xd2', type: 'construction', title: 'Cơi nới trái phép trên đất nông nghiệp', location: 'Khu ven rìa Tổ 5', aiSuggest: 'Hành vi vi phạm sử dụng đất. Đề xuất: Giao Địa chính và Đô thị xuống kiểm tra hiện trạng, lập hồ sơ cưỡng chế.', assignee: 'Cán bộ Địa chính & Đô thị' },
      { id: 'xd3', type: 'construction', title: 'Đào đường thi công không rào chắn', location: 'Đường Nguyễn Trãi', aiSuggest: 'Nguy cơ tai nạn giao thông cao. Đề xuất: Phạt nhà thầu thi công, yêu cầu lắp rào chắn và đèn cảnh báo ban đêm ngay lập tức.', assignee: 'Cán bộ Giao thông - Đô thị' },
      { id: 'xd4', type: 'construction', title: 'Nắp cống bị vỡ sập', location: 'Ngã tư Lê Lợi - Hai Bà Trưng', aiSuggest: 'Sự cố hạ tầng khẩn cấp. Đề xuất: Đặt ngay biển cảnh báo, giao đơn vị công ích đo đạc và thay nắp cống mới trong ngày.', assignee: 'Bộ phận Hạ tầng kỹ thuật' },
      { id: 'xd5', type: 'construction', title: 'Thi công ban đêm gây ồn ào', location: 'Khu dân cư mới, Tổ 8', aiSuggest: 'Vi phạm quy định tiếng ồn khu dân cư. Đề xuất: Cử công an phường xuống kiểm tra giấy phép thi công đêm, lập biên bản nhắc nhở.', assignee: 'Công an phường' }
    ]
  },
  env: {
    title: "Tài nguyên & Môi trường",
    kpis: [ 
      { label: "Điểm thu gom rác", value: "24", unit: "điểm", subtext: "Hoạt động bình thường", color: "blue", icon: "MapPin" }, 
      { label: "Chỉ số AQI", value: "45", unit: "(Tốt)", subtext: "Chất lượng không khí", color: "emerald", icon: "Activity" }, 
      { label: "Ô nhiễm tiếng ồn", value: "3", unit: "phản ánh", subtext: "Quán ăn, Karaoke", color: "amber", icon: "AlertCircle" }, 
      { label: "Xả thải trái phép", value: "2", unit: "vụ việc", subtext: "Nước thải, khói bụi", color: "red", icon: "AlertTriangle" } 
    ],
    scenarios: [
      { id: 'mt1', type: 'env', title: 'Xả nước thải đen ra mương sinh hoạt', location: 'Kênh nhánh sau chợ', aiSuggest: 'Có dấu hiệu xả thải công nghiệp chưa qua xử lý. Đề xuất: Phối hợp Phòng TNMT Quận xuống lấy mẫu nước xét nghiệm và truy xuất nguồn xả.', assignee: 'Cán bộ Môi trường & Quy tắc' },
      { id: 'mt2', type: 'env', title: 'Đốt rác thải nhựa gây khói độc', location: 'Bãi đất trống Tổ 7', aiSuggest: 'Gây ô nhiễm không khí và nguy cơ cháy lan. Đề xuất: Cử lực lượng dân phòng dập tắt ngay, rà soát camera phạt nguội người vi phạm.', assignee: 'Công an phường & Dân phòng' },
      { id: 'mt3', type: 'env', title: 'Ô nhiễm tiếng ồn từ quán Karaoke', location: 'Khu phố 1', aiSuggest: 'Phản ánh tiếng ồn vượt mức sau 22h. Đề xuất: Tổ chức đoàn liên ngành kiểm tra độ ồn đột xuất, rút giấy phép nếu tái phạm nhiều lần.', assignee: 'Tổ kiểm tra Liên ngành Văn hóa' },
      { id: 'mt4', type: 'env', title: 'Tiếng ồn từ xưởng cơ khí trong khu dân cư', location: 'Ngõ 12', aiSuggest: 'Ảnh hưởng trực tiếp đến sinh hoạt người dân. Đề xuất: Yêu cầu xưởng cam kết hoạt động đúng giờ và làm vách cách âm.', assignee: 'Cán bộ Môi trường' },
      { id: 'mt5', type: 'env', title: 'Hát loa kéo kẹo kéo quá giờ', location: 'Khu vực xóm trọ', aiSuggest: 'Gây bức xúc trong cộng đồng dân cư. Đề xuất: Tổ trưởng dân phố và Cảnh sát khu vực xuống nhắc nhở, thu giữ loa nếu chống đối.', assignee: 'Cảnh sát khu vực' }
    ]
  },
  security: {
    title: "An ninh Trật tự - ATGT",
    kpis: [ 
      { label: "Camera hoạt động", value: "128", unit: "/130 cam", subtext: "Bao phủ 98% địa bàn", color: "emerald", icon: "ShieldAlert" }, 
      { label: "Tụ tập đông người", value: "1", unit: "điểm", subtext: "Công viên trung tâm", color: "amber", icon: "Users" }, 
      { label: "Chắn lối PCCC", value: "1", unit: "vụ việc", subtext: "Cản trở lưu thông", color: "amber", icon: "AlertCircle" }, 
      { label: "Mất tín hiệu Cam", value: "2", unit: "camera", subtext: "Đang sửa chữa", color: "red", icon: "AlertTriangle" } 
    ],
    scenarios: [
      { id: 'an1', type: 'security', title: 'Mất tín hiệu 02 Camera An ninh', location: 'Ngã tư chợ & Công viên', aiSuggest: 'Mất tầm nhìn giám sát trọng yếu. Đề xuất: Điều động tổ IT xuống hiện trường kiểm tra cáp quang và nguồn điện.', assignee: 'Tổ Công nghệ thông tin' },
      { id: 'an2', type: 'security', title: 'Tụ tập đông người gây rối đêm khuya', location: 'Công viên trung tâm phường', aiSuggest: 'Nguy cơ mất an ninh trật tự. Đề xuất: Cử ngay tổ tuần tra Công an phường xuống hiện trường giải tán đám đông.', assignee: 'Trực ban Công an phường' },
      { id: 'an3', type: 'security', title: 'Đậu ô tô chắn ngang hẻm cứu hỏa', location: 'Đầu hẻm 20', aiSuggest: 'Cản trở lưu thông và PCCC. Đề xuất: Thông báo loa tìm chủ xe, nếu sau 15p không có mặt tiến hành cẩu xe, phạt vi phạm.', assignee: 'Cảnh sát Giao thông - Trật tự' },
      { id: 'an4', type: 'security', title: 'Tai nạn va quẹt giao thông cục bộ', location: 'Ngã tư cổng chợ', aiSuggest: 'Đang gây ùn tắc giao thông cục bộ. Đề xuất: Cử 2 đồng chí dân quân tự vệ ra phân luồng tạm thời chờ CSGT xử lý.', assignee: 'Tổ Bảo vệ An ninh trật tự' },
      { id: 'an5', type: 'security', title: 'Báo động cháy giả tại chung cư mini', location: 'Chung cư X, Tổ 4', aiSuggest: 'Hệ thống báo cháy kích hoạt nhưng không có khói. Đề xuất: Yêu cầu BQL kiểm tra tủ trung tâm báo cháy và reset.', assignee: 'Cán bộ PCCC phường' }
    ]
  },
  business: {
    title: "Doanh nghiệp & Thương mại",
    kpis: [ 
      { label: "Tổng hộ kinh doanh", value: "850", unit: "cơ sở", subtext: "Đang hoạt động", color: "blue", icon: "Briefcase" }, 
      { label: "Lấn chiếm vỉa hè", value: "2", unit: "cơ sở", subtext: "Kinh doanh lấn chiếm", color: "amber", icon: "MapPin" }, 
      { label: "PCCC vi phạm", value: "1", unit: "cơ sở", subtext: "Nguy cơ cháy nổ", color: "red", icon: "ShieldAlert" }, 
      { label: "VSATTP vi phạm", value: "2", unit: "cơ sở", subtext: "Thực phẩm không rõ", color: "red", icon: "AlertTriangle" } 
    ],
    scenarios: [
      { id: 'dn1', type: 'business', title: 'Kinh doanh thực phẩm không rõ nguồn gốc', location: 'Cửa hàng tạp hóa A, Tổ 2', aiSuggest: 'Nguy cơ ngộ độc thực phẩm. Đề xuất: Giao đoàn kiểm tra liên ngành VSATTP xuống kiểm tra hóa đơn chứng từ, tịch thu hàng hóa nếu vi phạm.', assignee: 'Tổ Liên ngành VSATTP' },
      { id: 'dn2', type: 'business', title: 'Bán thịt tươi sống sai quy định lưu trữ', location: 'Khu chợ tạm', aiSuggest: 'Thịt để dưới nền đất không đảm bảo vệ sinh. Đề xuất: Ban quản lý chợ nhắc nhở và yêu cầu kê kệ cao theo quy định.', assignee: 'Ban Quản lý Chợ' },
      { id: 'dn3', type: 'business', title: 'Cơ sở kinh doanh gas không đảm bảo PCCC', location: 'Đại lý Gas B', aiSuggest: 'Nguy cơ cháy nổ cực kỳ cao. Đề xuất: Kiểm tra ngay lập tức, nếu phát hiện vi phạm tiến hành niêm phong, đình chỉ hoạt động.', assignee: 'Cán bộ PCCC' },
      { id: 'dn4', type: 'business', title: 'Tiểu thương chợ lấn chiếm lòng đường', location: 'Khu vực cổng chợ chính', aiSuggest: 'Gây ách tắc giao thông giờ cao điểm. Đề xuất: Giao Ban quản lý chợ kẻ vạch sơn phân định, kiên quyết thu giữ hàng hóa lấn vạch.', assignee: 'Ban Quản lý Chợ & Trật tự' },
      { id: 'dn5', type: 'business', title: 'Lắp đặt biển quảng cáo sai quy định cỡ lớn', location: 'Mặt tiền đường lớn', aiSuggest: 'Vi phạm quy định quảng cáo, che khuất tầm nhìn. Đề xuất: Lập biên bản yêu cầu cơ sở tự tháo dỡ trong 24h.', assignee: 'Cán bộ Văn hóa - Đô thị' }
    ]
  },
  education: {
    title: "Giáo dục",
    kpis: [ 
      { label: "Điểm trường", value: "7", unit: "cơ sở", subtext: "Các cấp học", color: "blue", icon: "Landmark" }, 
      { label: "Sĩ số học sinh", value: "4,500", unit: "em", subtext: "Toàn phường", color: "emerald", icon: "GraduationCap" }, 
      { label: "Ùn tắc cổng trường", value: "2", unit: "điểm", subtext: "Giờ tan tầm", color: "red", icon: "AlertCircle" }, 
      { label: "Nguy cơ ANTT", value: "1", unit: "vụ việc", subtext: "Bạo lực, VSATTP", color: "red", icon: "AlertTriangle" } 
    ],
    scenarios: [
      { id: 'gd1', type: 'education', title: 'Ùn tắc giao thông nghiêm trọng giờ tan tầm', location: 'Cổng trường Tiểu học A', aiSuggest: 'Phụ huynh đỗ xe tràn xuống lòng đường. Đề xuất: Phối hợp Đoàn thanh niên và Công an phường cắm chốt phân luồng từ 16h30.', assignee: 'Công an & Đoàn Thanh niên' },
      { id: 'gd2', type: 'education', title: 'Phụ huynh lấn chiếm vỉa hè cổng trường MN', location: 'Cổng trường Mầm non B', aiSuggest: 'Gây mất an toàn cho trẻ. Đề xuất: Kẻ lại vạch dừng đỗ xe cho phụ huynh, cử dân phòng hướng dẫn xếp xe.', assignee: 'Tổ Trật tự & Dân phòng' },
      { id: 'gd3', type: 'education', title: 'Bán quà vặt trước cổng trường mất VSATTP', location: 'Vỉa hè trường THCS', aiSuggest: 'Nguy cơ ngộ độc cho học sinh. Đề xuất: Đội quy tắc đô thị xuống dẹp bỏ các xe đẩy bán hàng rong không phép.', assignee: 'Đội Trật tự Đô thị' },
      { id: 'gd4', type: 'education', title: 'Nguy cơ bạo lực học đường (Học sinh xô xát)', location: 'Khu vực sau trường học', aiSuggest: 'Ảnh hưởng an ninh học đường. Đề xuất: Công an khu vực trích xuất camera, phối hợp nhà trường mời phụ huynh làm việc.', assignee: 'Công an khu vực' },
      { id: 'gd5', type: 'education', title: 'Cây xanh mục rỗng trong sân trường', location: 'Trường Mầm non B', aiSuggest: 'Nguy cơ gãy đổ mùa mưa bão. Đề xuất: Giao bộ phận Đô thị liên hệ công ty Cây xanh đến cắt tỉa, đốn hạ cành nguy hiểm.', assignee: 'Cán bộ Đô thị' }
    ]
  },
  health: {
    title: "Y tế",
    kpis: [ 
      { label: "Lượt khám y tế", value: "45", unit: "lượt/ngày", subtext: "Tại trạm y tế", color: "blue", icon: "HeartPulse" }, 
      { label: "Tiêm chủng thiếu", value: "45", unit: "trẻ em", subtext: "Cần vận động thêm", color: "amber", icon: "User" }, 
      { label: "Chất lượng nước", value: "1", unit: "vấn đề", subtext: "Nước sinh hoạt", color: "amber", icon: "AlertCircle" }, 
      { label: "Dịch bệnh, Rác YT", value: "2", unit: "vụ việc", subtext: "Nguy cơ cao", color: "red", icon: "AlertTriangle" } 
    ],
    scenarios: [
      { id: 'yt1', type: 'health', title: 'Phát hiện ổ dịch Sốt xuất huyết nhỏ', location: 'Khu nhà trọ Tổ 2', aiSuggest: 'Nguy cơ bùng phát dịch bệnh lây nhiễm. Đề xuất: Giao Trạm y tế khoanh vùng, phun thuốc diệt muỗi và tuyên truyền người dân dọn lu vại.', assignee: 'Trạm Y tế phường' },
      { id: 'yt2', type: 'health', title: 'Phòng khám nha khoa tư nhân xả rác y tế sai quy định', location: 'Đường chính', aiSuggest: 'Vi phạm nghiêm trọng quy định rác thải độc hại. Đề xuất: Kiểm tra đột xuất, lập biên bản xử phạt và đình chỉ hoạt động nếu cần.', assignee: 'Cán bộ Y tế & Môi trường' },
      { id: 'yt3', type: 'health', title: '45 trẻ em chưa tiêm chủng viêm não Nhật Bản', location: 'Tổ dân phố 4', aiSuggest: 'Tỷ lệ tiêm chủng đang thấp. Đề xuất: Giao Tổ trưởng TDP đến từng hộ gia đình có trẻ em vận động đi tiêm bổ sung.', assignee: 'Trạm Y tế & Tổ trưởng TDP' },
      { id: 'yt4', type: 'health', title: 'Thiếu vật tư y tế sơ cấp cứu tại Trạm', location: 'Trạm Y tế Phường', aiSuggest: 'Ảnh hưởng công tác khám chữa bệnh cơ sở. Đề xuất: Lập tờ trình khẩn gửi Trung tâm Y tế Quận xin cấp bổ sung cơ số thuốc.', assignee: 'Trưởng Trạm Y tế' },
      { id: 'yt5', type: 'health', title: 'Phản ánh chất lượng nước sinh hoạt đục, có mùi', location: 'Khu dân cư A', aiSuggest: 'Nguy cơ ảnh hưởng sức khỏe diện rộng. Đề xuất: Lấy mẫu nước xét nghiệm khẩn cấp, yêu cầu công ty cấp nước thau rửa đường ống.', assignee: 'Cán bộ Y tế & Hạ tầng' }
    ]
  },
  economy: {
    title: "Kinh tế - Xã hội",
    kpis: [ 
      { label: "Thu ngân sách", value: "75%", unit: "kế hoạch", subtext: "Hoàn thành Quý", color: "emerald", icon: "BarChart3" }, 
      { label: "Tranh chấp dân sự", value: "2", unit: "vụ việc", subtext: "Hòa giải cơ sở", color: "amber", icon: "Users" }, 
      { label: "Chậm thu quỹ", value: "1", unit: "loại quỹ", subtext: "Cần tuyên truyền", color: "amber", icon: "AlertCircle" }, 
      { label: "Hỏa hoạn, Bạo lực", value: "2", unit: "vụ việc", subtext: "Cứu trợ, Can thiệp", color: "red", icon: "HeartPulse" } 
    ],
    scenarios: [
      { id: 'kx1', type: 'economy', title: 'Hộ neo đơn cần cứu trợ khẩn cấp do hỏa hoạn', location: 'Nhà bà M, Tổ 3', aiSuggest: 'Đảm bảo an sinh xã hội khẩn cấp. Đề xuất: Ủy ban MTTQ phường xuất quỹ cứu trợ, bố trí chỗ ở tạm và nhu yếu phẩm.', assignee: 'Cán bộ LĐTBXH & MTTQ' },
      { id: 'kx2', type: 'economy', title: 'Xung đột, tranh chấp ranh giới đất đai giữa 2 hộ', location: 'Hẻm 7', aiSuggest: 'Nguy cơ mất đoàn kết xóm làng. Đề xuất: Giao Tổ hòa giải cơ sở xuống nắm tình hình, tổ chức buổi hòa giải có sự tham gia của địa chính.', assignee: 'Tổ Hòa giải & Địa chính' },
      { id: 'kx3', type: 'economy', title: 'Tranh chấp tiếng ồn sinh hoạt hàng xóm', location: 'Tổ 5', aiSuggest: 'Cần giải quyết mâu thuẫn từ cơ sở. Đề xuất: Tổ trưởng dân phố tiến hành hòa giải khuyên can các bên.', assignee: 'Tổ trưởng TDP 5' },
      { id: 'kx4', type: 'economy', title: 'Chậm tiến độ thu quỹ Đền ơn đáp nghĩa', location: 'Toàn phường', aiSuggest: 'Ảnh hưởng chỉ tiêu kinh tế - xã hội. Đề xuất: Họp giao ban các Tổ trưởng TDP, đôn đốc phương án tuyên truyền thu quỹ.', assignee: 'Cán bộ Tài chính - Kế toán' },
      { id: 'kx5', type: 'economy', title: 'Phát hiện bạo lực gia đình nghiêm trọng', location: 'Tổ dân phố 6', aiSuggest: 'Xâm phạm tính mạng, sức khỏe công dân. Đề xuất: Công an phường can thiệp ngay lập tức, cách ly nạn nhân và xử lý đối tượng.', assignee: 'Công an & Phụ nữ phường' }
    ]
  }
};

const INITIAL_TASKS = [
  { id: 'T-[DOCS]-001', title: 'Rà soát quy trình cấp phép xây dựng tổ 4', assignee: 'Nguyễn Văn A', status: 'In Progress', priority: 'Medium', date: '2026-04-01', sourceType: 'docs' },
];

const apiKey = "AIzaSyDExuyxm0fqxnHwGGu7LF_4snQ1QK4KLBM";
const callGeminiAPI = async (prompt) => {
const url = `https://generativelanguage.googleapis.com/v1beta/models/gemini-2.5-flash:generateContent?key=${apiKey}`;
  const payload = { contents: [{ parts: [{ text: prompt }] }] };
  let retries = 5;
  let delay = 1000;
  while (retries > 0) {
    try {
      const response = await fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) });
      if (!response.ok) throw new Error('API Error');
      const data = await response.json();
      return data.candidates?.[0]?.content?.parts?.[0]?.text || "Không có phản hồi từ AI.";
    } catch (error) {
      retries--;
      if (retries === 0) return "Lỗi kết nối AI. Vui lòng thử lại sau.";
      await new Promise(res => setTimeout(res, delay));
      delay *= 2;
    }
  }
};

export default function App() {
  const [currentScreen, setCurrentScreen] = useState('login'); 
  const [role, setRole] = useState('');
  const [activeDetail, setActiveDetail] = useState(null);
  const [isAIOpen, setIsAIOpen] = useState(false);
  const [isNganhOpen, setIsNganhOpen] = useState(true); 
  
  const [tasks, setTasks] = useState(INITIAL_TASKS);

  const [workflowState, setWorkflowState] = useState({
    docFlow: 'alert', 
    dataFlow: 'alert',
    mapFlow: 'alert',
  });

  const [chatInput, setChatInput] = useState('');
  const [chatHistory, setChatHistory] = useState([]);
  const [isChatLoading, setIsChatLoading] = useState(false);
  const [aiAnalysis, setAiAnalysis] = useState(null);
  const [isAnalysisLoading, setIsAnalysisLoading] = useState(false);
  const [draftReport, setDraftReport] = useState('');
  const [isDrafting, setIsDrafting] = useState(false);
  const chatEndRef = useRef(null);

  useEffect(() => {
    setAiAnalysis(null);
    setDraftReport('');
  }, [activeDetail]);

  const navigate = (screen, detail = null) => {
    setCurrentScreen(screen);
    setActiveDetail(detail);
    window.scrollTo(0, 0);
  };

  const handleLogin = (selectedRole) => {
    setRole(selectedRole);
    navigate('hub');
  };

  const createTask = (type, data) => {
    const newTask = {
      id: `T-[${type.toUpperCase()}]-00${tasks.length + 2}`,
      title: data.title,
      assignee: data.assignee || 'Trần Thị B',
      status: 'To Do',
      priority: 'High',
      date: new Date().toISOString().split('T')[0],
      sourceType: type
    };
    setTasks([newTask, ...tasks]);
    
    if (['doc', 'data', 'map'].includes(type) || ['docs', 'reports'].includes(type)) {
      const flowType = type === 'docs' ? 'doc' : type === 'reports' ? 'map' : type;
      setWorkflowState(prev => ({
        ...prev,
        [`${flowType}Flow`]: 'task_created'
      }));
    }

    navigate('gos_tasks');
  };

  const resolveTask = (taskId, type) => {
    setTasks(tasks.map(t => t.id === taskId ? { ...t, status: 'Done' } : t));
    
    if (['doc', 'data', 'map', 'docs', 'reports'].includes(type)) {
      const flowType = type === 'docs' ? 'doc' : type === 'reports' ? 'map' : type;
      setWorkflowState(prev => ({
        ...prev,
        [`${flowType}Flow`]: 'resolved'
      }));
    }
    navigate('dashboard');
  };

  const handleAskAI = async (customPrompt = null) => {
    const query = customPrompt || chatInput;
    if (!query.trim()) return;
    
    const newHistory = [...chatHistory, { role: 'user', content: query }];
    setChatHistory(newHistory);
    setChatInput('');
    setIsChatLoading(true);

    const systemContext = `Bạn là trợ lý AI thông minh cho Chủ tịch phường Vĩnh Yên. Trả lời ngắn gọn, chuyên nghiệp, ngôn ngữ quản lý nhà nước. Nếu được yêu cầu dự thảo, hãy viết khoảng 2-3 câu quyết đoán.`;
    const fullPrompt = `${systemContext}\n\nNgười dùng hỏi: ${query}`;
    
    const reply = await callGeminiAPI(fullPrompt);
    setChatHistory([...newHistory, { role: 'ai', content: reply }]);
    setIsChatLoading(false);
  };

  useEffect(() => {
    chatEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [chatHistory, isAIOpen]);

  const handleAnalyzeDetail = async () => {
    setIsAnalysisLoading(true);
    const prompt = `Phân tích nguyên nhân và đề xuất 3 gạch đầu dòng hướng xử lý cho vấn đề cấp phường sau:\nTiêu đề: ${activeDetail.title}\nVị trí: ${activeDetail.location || 'Không rõ'}\nVăn phong hành chính công, quyết đoán, súc tích. Không dùng định dạng markdown phức tạp.`;
    const result = await callGeminiAPI(prompt);
    setAiAnalysis(result);
    setIsAnalysisLoading(false);
  };

  const handleDraftReport = async (taskTitle) => {
    setIsDrafting(true);
    const prompt = `Soạn 1 đoạn báo cáo kết quả (2-3 câu) xác nhận hoàn thành công việc: "${taskTitle}". Văn phong báo cáo hành chính, ngắn gọn.`;
    const result = await callGeminiAPI(prompt);
    setDraftReport(result);
    setIsDrafting(false);
  };

  const SidebarItem = ({ icon: Icon, label, screenId, isActive, isSubItem = false }) => (
    <div 
      onClick={() => navigate(screenId)}
      className={`flex items-center gap-3 py-2.5 cursor-pointer rounded-lg transition-colors
        ${isSubItem ? 'pl-9 pr-4 text-sm' : 'px-4'}
        ${isActive 
          ? 'bg-blue-600 text-white' 
          : 'text-slate-400 hover:bg-slate-800 hover:text-slate-200'}`}
    >
      <Icon size={18} className={isSubItem ? "opacity-70" : ""} />
      <span className={isSubItem ? "font-normal" : "font-medium text-sm"}>{label}</span>
    </div>
  );

  const StatusBadge = ({ status }) => {
    const styles = {
      'To Do': 'bg-slate-100 text-slate-600 border-slate-200',
      'In Progress': 'bg-blue-50 text-blue-600 border-blue-200',
      'Done': 'bg-green-50 text-green-600 border-green-200',
      'Overdue': 'bg-red-50 text-red-600 border-red-200',
    };
    return (
      <span className={`px-2.5 py-1 text-xs font-semibold rounded-full border ${styles[status] || styles['To Do']}`}>
        {status}
      </span>
    );
  };

  if (currentScreen === 'login') {
    return (
      <div className="min-h-screen bg-[#0a0f24] relative flex items-center justify-center overflow-hidden font-sans">
        <div className="absolute inset-0 bg-[linear-gradient(rgba(56,189,248,0.04)_1px,transparent_1px),linear-gradient(90deg,rgba(56,189,248,0.04)_1px,transparent_1px)] bg-[size:40px_40px] pointer-events-none"></div>
        <div className="absolute bottom-0 left-0 w-full h-[60vh] bg-[url('https://images.unsplash.com/photo-1506905925346-21bda4d32df4?q=80&w=2070&auto=format&fit=crop')] bg-cover bg-bottom opacity-30 mix-blend-screen pointer-events-none" style={{ WebkitMaskImage: 'linear-gradient(to top, rgba(0,0,0,1), rgba(0,0,0,0))', maskImage: 'linear-gradient(to top, rgba(0,0,0,1), rgba(0,0,0,0))' }}></div>
        
        <div className="relative z-10 w-full max-w-md bg-white/95 backdrop-blur-xl border border-white/20 rounded-[2rem] shadow-[0_0_50px_rgba(0,0,0,0.5)] p-8 animate-in zoom-in-95 duration-500">
          <div className="text-center mb-8">
            <div className="w-20 h-20 mx-auto mb-5 flex items-center justify-center drop-shadow-xl">
              <img src="https://upload.wikimedia.org/wikipedia/commons/a/a3/Emblem_of_Vietnam.svg" alt="Quốc huy Việt Nam" className="w-full h-full object-contain" />
            </div>
            <h2 className="text-2xl font-extrabold text-slate-800 mb-1">Đăng nhập Hệ thống</h2>
            <p className="text-slate-500 text-sm font-medium">Mô hình Vận hành số Phường Vĩnh Yên</p>
          </div>
          
          <div className="space-y-4">
            <button onClick={() => handleLogin('Chủ tịch UBND Phường')} className="w-full flex items-center justify-between bg-slate-50 hover:bg-blue-50 border border-slate-200 hover:border-blue-300 p-4 rounded-xl text-left transition-all duration-300 group">
              <div className="flex items-center gap-4">
                <div className="w-10 h-10 rounded-full bg-blue-100 text-blue-600 flex items-center justify-center group-hover:scale-110 group-hover:bg-blue-600 group-hover:text-white transition-all">
                  <User size={20}/>
                </div>
                <div>
                  <p className="text-slate-800 font-bold group-hover:text-blue-700">Lãnh đạo Phường</p>
                  <p className="text-xs text-slate-500 mt-0.5">Góc nhìn tổng quan, ra quyết định</p>
                </div>
              </div>
              <ChevronRight className="text-slate-400 group-hover:text-blue-600" />
            </button>

            <button onClick={() => handleLogin('Trưởng bộ phận Một cửa')} className="w-full flex items-center justify-between bg-slate-50 hover:bg-amber-50 border border-slate-200 hover:border-amber-300 p-4 rounded-xl text-left transition-all duration-300 group">
              <div className="flex items-center gap-4">
                <div className="w-10 h-10 rounded-full bg-amber-100 text-amber-600 flex items-center justify-center group-hover:scale-110 group-hover:bg-amber-500 group-hover:text-white transition-all">
                  <Briefcase size={20}/>
                </div>
                <div>
                  <p className="text-slate-800 font-bold group-hover:text-amber-700">Trưởng bộ phận / Khối</p>
                  <p className="text-xs text-slate-500 mt-0.5">Góc nhìn chuyên đề, điều phối G-OS</p>
                </div>
              </div>
              <ChevronRight className="text-slate-400 group-hover:text-amber-600" />
            </button>

            <button onClick={() => handleLogin('Cán bộ thực thi')} className="w-full flex items-center justify-between bg-slate-50 hover:bg-emerald-50 border border-slate-200 hover:border-emerald-300 p-4 rounded-xl text-left transition-all duration-300 group">
              <div className="flex items-center gap-4">
                <div className="w-10 h-10 rounded-full bg-emerald-100 text-emerald-600 flex items-center justify-center group-hover:scale-110 group-hover:bg-emerald-500 group-hover:text-white transition-all">
                  <HardHat size={20}/>
                </div>
                <div>
                  <p className="text-slate-800 font-bold group-hover:text-emerald-700">Cán bộ thực thi</p>
                  <p className="text-xs text-slate-500 mt-0.5">Góc nhìn hiện trường, báo cáo tiến độ</p>
                </div>
              </div>
              <ChevronRight className="text-slate-400 group-hover:text-emerald-600" />
            </button>
          </div>
        </div>
      </div>
    );
  }

  const renderHub = () => {
    const hubItems = [
      { title: 'Kinh tế - Xã hội', icon: <Landmark size={30} />, pos: 'top-[-5%] left-[50%] -translate-x-1/2 -translate-y-1/2', color: 'text-amber-400', glow: 'group-hover:shadow-[0_0_30px_rgba(251,191,36,0.6)]', borderColor: 'border-amber-400/60 group-hover:border-amber-400', action: () => navigate('economy') },
      { title: 'Hành chính công', icon: <FileText size={30} />, pos: 'top-[15%] left-[85%] -translate-x-1/2 -translate-y-1/2', color: 'text-blue-400', glow: 'group-hover:shadow-[0_0_30px_rgba(96,165,250,0.6)]', borderColor: 'border-blue-400/60 group-hover:border-blue-400', alert: workflowState.docFlow === 'alert', action: () => navigate('docs') },
      { title: 'Xây dựng đô thị', icon: <HardHat size={30} />, pos: 'top-[50%] left-[105%] -translate-x-1/2 -translate-y-1/2', color: 'text-cyan-400', glow: 'group-hover:shadow-[0_0_30px_rgba(34,211,238,0.6)]', borderColor: 'border-cyan-400/60 group-hover:border-cyan-400', action: () => navigate('construction') },
      { title: 'Tài nguyên môi trường', icon: <TreePine size={30} />, pos: 'top-[85%] left-[85%] -translate-x-1/2 -translate-y-1/2', color: 'text-emerald-400', glow: 'group-hover:shadow-[0_0_30px_rgba(52,211,153,0.6)]', borderColor: 'border-emerald-400/60 group-hover:border-emerald-400', alert: workflowState.mapFlow === 'alert', action: () => navigate('env') },
      { title: 'An ninh trật tự - ATGT', icon: <ShieldAlert size={30} />, pos: 'top-[105%] left-[50%] -translate-x-1/2 -translate-y-1/2', color: 'text-green-400', glow: 'group-hover:shadow-[0_0_30px_rgba(74,222,128,0.6)]', borderColor: 'border-green-400/60 group-hover:border-green-400', action: () => navigate('security') },
      { title: 'Doanh nghiệp & Thương mại', icon: <Briefcase size={30} />, pos: 'top-[85%] left-[15%] -translate-x-1/2 -translate-y-1/2', color: 'text-orange-400', glow: 'group-hover:shadow-[0_0_30px_rgba(251,146,60,0.6)]', borderColor: 'border-orange-400/60 group-hover:border-orange-400', action: () => navigate('business') },
      { title: 'Giáo dục', icon: <GraduationCap size={30} />, pos: 'top-[50%] left-[-5%] -translate-x-1/2 -translate-y-1/2', color: 'text-red-400', glow: 'group-hover:shadow-[0_0_30px_rgba(248,113,113,0.6)]', borderColor: 'border-red-400/60 group-hover:border-red-400', action: () => navigate('education') },
      { title: 'Y tế', icon: <HeartPulse size={30} />, pos: 'top-[15%] left-[15%] -translate-x-1/2 -translate-y-1/2', color: 'text-pink-400', glow: 'group-hover:shadow-[0_0_30px_rgba(244,114,182,0.6)]', borderColor: 'border-pink-400/60 group-hover:border-pink-400', action: () => navigate('health') },
    ];

    return (
      <div className="flex-1 relative overflow-hidden bg-blue-950 flex flex-col items-center justify-center min-h-screen font-sans">
        <div className="absolute inset-0 bg-[linear-gradient(rgba(56,189,248,0.04)_1px,transparent_1px),linear-gradient(90deg,rgba(56,189,248,0.04)_1px,transparent_1px)] bg-[size:40px_40px] pointer-events-none"></div>
        <div className="absolute inset-0 bg-gradient-to-b from-blue-900/60 via-blue-950/80 to-slate-900/95 pointer-events-none"></div>
        <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1506905925346-21bda4d32df4?q=80&w=2070&auto=format&fit=crop')] bg-cover bg-center opacity-40 animate-breath origin-center pointer-events-none"></div>

        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          {[...Array(30)].map((_, i) => (
            <div key={i} className="absolute bg-blue-300 rounded-full mix-blend-screen"
                 style={{
                   width: Math.random() * 4 + 2 + 'px',
                   height: Math.random() * 4 + 2 + 'px',
                   top: Math.random() * 100 + '%',
                   left: Math.random() * 100 + '%',
                   opacity: Math.random() * 0.5 + 0.2,
                   animation: `particleFloat ${Math.random() * 5 + 5}s infinite ease-in-out ${Math.random() * 5}s`
                 }}>
            </div>
          ))}
        </div>

        <div className="absolute top-8 flex flex-col items-center w-full z-30">
          <img src="https://upload.wikimedia.org/wikipedia/commons/a/a3/Emblem_of_Vietnam.svg" alt="Quốc huy" className="w-16 h-16 drop-shadow-2xl mb-4" />
          <h1 className="text-2xl md:text-3xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-amber-300 to-orange-500 tracking-wide text-center drop-shadow-[0_2px_4px_rgba(0,0,0,0.8)] uppercase">
            TRUNG TÂM ĐIỀU HÀNH ĐÔ THỊ THÔNG MINH<br/>PHƯỜNG VĨNH YÊN
          </h1>
        </div>

        <div className="animate-in zoom-in-95 duration-700 mt-24">
          <div className="relative w-[400px] h-[400px] md:w-[500px] md:h-[500px] animate-float">
            <svg className="absolute inset-0 w-full h-full pointer-events-none" viewBox="0 0 500 500">
              <circle cx="250" cy="250" r="250" fill="none" stroke="rgba(255, 255, 255, 0.15)" strokeWidth="1" strokeDasharray="4 8" className="origin-center animate-[spin_40s_linear_infinite]" />
              <circle cx="250" cy="250" r="160" fill="none" stroke="rgba(56, 189, 248, 0.4)" strokeWidth="2" className="origin-center animate-[spin_60s_linear_infinite_reverse]" />
              <circle cx="250" cy="250" r="180" fill="none" stroke="rgba(251, 191, 36, 0.2)" strokeWidth="1" strokeDasharray="10 10" className="origin-center animate-[spin_80s_linear_infinite]" />
              {[0, 45, 90, 135, 180, 225, 270, 315].map(deg => {
                const rad = (deg - 90) * Math.PI / 180;
                const x1 = 250 + 160 * Math.cos(rad);
                const y1 = 250 + 160 * Math.sin(rad);
                const x2 = 250 + 250 * Math.cos(rad);
                const y2 = 250 + 250 * Math.sin(rad);
                return <line key={deg} x1={x1} y1={y1} x2={x2} y2={y2} stroke="rgba(255, 255, 255, 0.3)" strokeWidth="2" />;
              })}
            </svg>

            <div 
              onClick={() => navigate('dashboard')}
              className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-64 h-64 md:w-[320px] md:h-[320px] rounded-full border-4 border-white/40 shadow-[0_0_50px_rgba(255,255,255,0.2)] overflow-hidden z-10 flex items-center justify-center cursor-pointer group transition-transform duration-500 hover:scale-[1.02]"
            >
               <img src="https://img.youtube.com/vi/5GTgV9K_wFQ/hqdefault.jpg" alt="Vinh Yen Center" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" />
               <div className="absolute inset-0 bg-slate-900/40 flex items-center justify-center backdrop-blur-[2px] opacity-0 group-hover:opacity-100 transition-all duration-300">
                 <span className="bg-blue-600 text-white font-bold px-6 py-3 rounded-full flex items-center gap-2 shadow-xl transform translate-y-4 group-hover:translate-y-0 transition-transform duration-300">
                   <LayoutDashboard size={18}/> Vào Tổng Quan
                 </span>
               </div>
            </div>

            {hubItems.map((item, index) => (
              <div 
                key={index} 
                className={`absolute ${item.pos} flex flex-col items-center z-20 group cursor-pointer w-48`} 
                onClick={item.action}
              >
                <div className={`relative w-16 h-16 md:w-20 md:h-20 rounded-2xl border-2 bg-slate-900/90 backdrop-blur-xl flex items-center justify-center shadow-2xl transition-all duration-300 group-hover:scale-110 ${item.borderColor} ${item.glow} ${item.alert ? 'animate-pulse !border-red-500 shadow-[0_0_20px_rgba(239,68,68,0.8)]' : ''}`}>
                  <div className={item.color}>{item.icon}</div>
                  {item.alert && (
                    <span className="absolute -top-2 -right-2 w-5 h-5 bg-red-500 rounded-full border-2 border-slate-900 flex items-center justify-center">
                      <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75"></span>
                    </span>
                  )}
                </div>
                <span className="bg-slate-900/90 px-4 py-1.5 rounded-full border border-slate-700/50 mt-3 text-sm md:text-base font-bold text-white shadow-lg text-center drop-shadow-[0_2px_2px_rgba(0,0,0,0.8)] transition-colors w-max max-w-full">
                  {item.title}
                </span>
              </div>
            ))}
          </div>
        </div>

        <button onClick={() => navigate('login')} className="absolute bottom-8 right-8 text-white hover:text-blue-300 flex items-center gap-2 bg-slate-900/70 backdrop-blur-md px-6 py-3 rounded-full border border-slate-700/50 hover:border-blue-500 transition-all font-semibold shadow-lg z-30">
          <LogOut size={18} /> Đăng xuất
        </button>
      </div>
    );
  };

  const renderDashboard = () => (
    <div className="space-y-6 animate-in fade-in slide-in-from-bottom-4 duration-500">
      <div className="flex justify-between items-center">
        <div>
          <h2 className="text-2xl font-bold text-slate-800">Nhiệm vụ trọng tâm - Phường Vĩnh Yên</h2>
          <p className="text-slate-500 text-sm">Hệ thống giám sát và phản ứng nhanh (IOC)</p>
        </div>
      </div>

      <div className="grid grid-cols-4 gap-4">
        <div onClick={() => navigate('docs')} className="bg-white p-5 rounded-xl border border-slate-200 shadow-sm flex items-center justify-between cursor-pointer hover:border-blue-300 hover:shadow-md transition-all group">
          <div>
            <p className="text-sm text-slate-500 font-medium group-hover:text-blue-600 transition-colors mb-1">Hành chính công</p>
            <h3 className="text-2xl font-bold text-slate-800">{SECTOR_DATA.docs.kpis[1].value} <span className="text-sm font-normal text-slate-500">{SECTOR_DATA.docs.kpis[1].unit}</span></h3>
            <p className="text-xs text-slate-400 mt-1">{SECTOR_DATA.docs.kpis[0].value} {SECTOR_DATA.docs.kpis[0].unit}</p>
          </div>
          <div className="w-12 h-12 bg-blue-50 rounded-full flex items-center justify-center text-blue-600 group-hover:scale-110 transition-transform">
            <FileText size={24} />
          </div>
        </div>

        <div onClick={() => navigate('construction')} className="bg-white p-5 rounded-xl border border-slate-200 shadow-sm flex items-center justify-between cursor-pointer hover:border-emerald-300 hover:shadow-md transition-all group">
          <div>
            <p className="text-sm text-slate-500 font-medium group-hover:text-emerald-600 transition-colors mb-1">Xây dựng Đô thị</p>
            <h3 className="text-2xl font-bold text-slate-800">{SECTOR_DATA.construction.kpis[1].value} <span className="text-sm font-normal text-slate-500">{SECTOR_DATA.construction.kpis[1].unit}</span></h3>
            <p className="text-xs text-slate-400 mt-1">{SECTOR_DATA.construction.kpis[1].subtext}</p>
          </div>
          <div className="w-12 h-12 bg-emerald-50 rounded-full flex items-center justify-center text-emerald-600 group-hover:scale-110 transition-transform">
            <HardHat size={24} />
          </div>
        </div>

        <div onClick={() => navigate('security')} className="bg-white p-5 rounded-xl border border-slate-200 shadow-sm flex items-center justify-between cursor-pointer hover:border-amber-300 hover:shadow-md transition-all group border-l-4 border-l-amber-500">
          <div>
            <p className="text-sm text-slate-500 font-medium group-hover:text-amber-600 transition-colors mb-1">ANTT - ATGT</p>
            <h3 className="text-2xl font-bold text-slate-800">{SECTOR_DATA.security.kpis[0].value} <span className="text-sm font-normal text-slate-500">{SECTOR_DATA.security.kpis[0].unit}</span></h3>
            <p className="text-xs text-slate-400 mt-1">{SECTOR_DATA.security.kpis[0].subtext}</p>
          </div>
          <div className="w-12 h-12 bg-amber-50 rounded-full flex items-center justify-center text-amber-600 group-hover:scale-110 transition-transform">
            <ShieldAlert size={24} />
          </div>
        </div>

        <div onClick={() => navigate('education')} className="bg-white p-5 rounded-xl border border-slate-200 shadow-sm flex items-center justify-between cursor-pointer hover:border-red-300 hover:shadow-md transition-all group">
          <div>
            <p className="text-sm text-slate-500 font-medium group-hover:text-red-600 transition-colors mb-1">Giáo dục</p>
            <h3 className="text-2xl font-bold text-slate-800">{SECTOR_DATA.education.kpis[1].value} <span className="text-sm font-normal text-slate-500">{SECTOR_DATA.education.kpis[1].unit}</span></h3>
            <p className="text-xs text-slate-400 mt-1">Tại {SECTOR_DATA.education.kpis[0].value} điểm trường</p>
          </div>
          <div className="w-12 h-12 bg-red-50 rounded-full flex items-center justify-center text-red-600 group-hover:scale-110 transition-transform">
            <GraduationCap size={24} />
          </div>
        </div>
      </div>

      <div className="grid grid-cols-3 gap-6">
        <div className="col-span-2 bg-white rounded-xl border border-slate-200 shadow-sm p-6">
          <div className="flex items-center justify-between mb-4">
            <h3 className="text-lg font-bold text-slate-800 flex items-center gap-2">
              <AlertTriangle className="text-red-500" size={20} /> Cảnh báo cần xử lý
            </h3>
            <button onClick={() => navigate('alerts')} className="text-sm text-blue-600 hover:text-blue-700 font-medium flex items-center gap-1">
              Xem tất cả <ChevronRight size={16}/>
            </button>
          </div>
          
          <div className="space-y-3">
            {SECTOR_DATA.alerts.scenarios.slice(0,4).map((scenario, index) => {
               const isUrgent = index < 2;
               const colorTheme = isUrgent ? 'red' : 'amber';
               const Icon = isUrgent ? AlertCircle : AlertTriangle;

               if (scenario.id === 'cb1' && workflowState.docFlow === 'resolved') return null;

               return (
                <div 
                  key={scenario.id}
                  onClick={() => navigate('detail', { type: 'alerts', title: scenario.title, data: scenario })} 
                  className={`p-4 border border-${colorTheme}-200 bg-${colorTheme}-50 rounded-lg flex items-center justify-between cursor-pointer hover:bg-${colorTheme}-100 transition shadow-sm border-l-4 border-l-${colorTheme}-500`}
                >
                  <div className="flex items-center gap-3">
                    <div className={`w-10 h-10 rounded-full bg-${colorTheme}-100 flex items-center justify-center text-${colorTheme}-600`}>
                      <Icon size={20} />
                    </div>
                    <div>
                      <h4 className={`font-semibold text-${colorTheme}-800`}>{scenario.title}</h4>
                      <p className={`text-sm text-${colorTheme}-600`}>Vị trí: {scenario.location}</p>
                    </div>
                  </div>
                  <ChevronRight className={`text-${colorTheme}-400`} />
                </div>
               );
            })}
            
            {workflowState.docFlow === 'resolved' && (
               <div className="p-4 border border-green-200 bg-green-50 rounded-lg flex items-center gap-3 shadow-sm border-l-4 border-l-green-500 opacity-70">
                  <div className="w-10 h-10 rounded-full bg-green-100 flex items-center justify-center text-green-600"><CheckCircle2 size={20} /></div>
                  <div>
                    <h4 className="font-semibold text-green-800 line-through">[Hành chính] 7 Hồ sơ đất đai gần quá hạn</h4>
                    <p className="text-sm text-green-600">Đã giải quyết hoàn tất trên G-OS.</p>
                  </div>
               </div>
            )}
          </div>
        </div>

        <div className="bg-gradient-to-br from-indigo-900 to-purple-900 rounded-xl shadow-sm p-6 text-white relative overflow-hidden">
          <div className="absolute top-0 right-0 p-4 opacity-20"><Bot size={100} /></div>
          <div className="relative z-10">
            <h3 className="text-lg font-bold flex items-center gap-2 mb-4"><Sparkles className="text-purple-300" size={20} /> AI Summary</h3>
            <div className="space-y-4 text-sm text-purple-100">
              <p>Chào Lãnh đạo, tình hình 4 lĩnh vực trọng tâm:</p>
              <ul className="list-disc pl-4 space-y-2">
                {workflowState.docFlow === 'alert' ? <li className="text-red-300 font-semibold">Hành chính: Cần đốc thúc khẩn 7 hồ sơ đất đai.</li> : <li className="text-green-300">Hành chính: Đã giải quyết xong hồ sơ trễ hạn.</li>}
                <li>Đô thị: Có công trình xây sai phép vượt tầng tại Trần Phú.</li>
                <li>ATGT: Xe chắn hẻm cứu hỏa cần cẩu dời khẩn cấp.</li>
                <li>Giáo dục: Ùn tắc cổng trường Tiểu học A giờ tan tầm.</li>
              </ul>
              <button onClick={() => setIsAIOpen(true)} className="w-full mt-4 bg-white/20 hover:bg-white/30 text-white py-2 rounded-lg transition text-xs font-semibold flex items-center justify-center gap-2">
                Mở trợ lý điều hành chi tiết <ChevronRight size={14} />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  const renderSectorDashboard = (sectorId) => {
    const sector = SECTOR_DATA[sectorId];
    if (!sector) return null;

    return (
      <div className="space-y-6 animate-in fade-in slide-in-from-bottom-4 duration-500">
        <div className="flex justify-between items-center border-b border-slate-200 pb-4">
          <div>
            <h2 className="text-2xl font-bold text-slate-800">Quản lý chuyên đề: {sector.title}</h2>
            <p className="text-slate-500 text-sm">Hệ thống giám sát, phân tích số liệu và xử lý tình huống nghiệp vụ.</p>
          </div>
          <span className="bg-blue-100 text-blue-700 px-3 py-1 rounded-full text-sm font-semibold flex items-center gap-2"><Activity size={16}/> Đang giám sát trực tuyến</span>
        </div>

        <div className="grid grid-cols-4 gap-4">
          {sector.kpis.map((kpi, idx) => {
            const KpiIcon = iconMap[kpi.icon] || Activity;
            return (
              <div key={idx} className={`bg-white p-5 rounded-xl border border-slate-200 shadow-sm flex items-center justify-between transition-all hover:shadow-md hover:border-${kpi.color}-300 group border-l-4 border-l-${kpi.color}-500`}>
                <div>
                  <p className={`text-sm text-slate-500 font-medium group-hover:text-${kpi.color}-600 transition-colors mb-1`}>{kpi.label}</p>
                  <h3 className="text-2xl font-bold text-slate-800">{kpi.value} <span className="text-sm font-normal text-slate-500">{kpi.unit}</span></h3>
                  <p className="text-xs text-slate-400 mt-1">{kpi.subtext}</p>
                </div>
                <div className={`w-12 h-12 bg-${kpi.color}-50 rounded-full flex items-center justify-center text-${kpi.color}-600 group-hover:scale-110 transition-transform`}>
                  <KpiIcon size={24} />
                </div>
              </div>
            );
          })}
        </div>

        <div className="bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden">
          <div className="p-5 border-b border-slate-200 bg-slate-50 flex items-center justify-between">
            <div className="flex items-center gap-2">
              <AlertCircle className="text-slate-500" size={20}/>
              <h3 className="font-bold text-slate-800 text-lg">Tình huống cần xử lý cấp bách (IOC phát hiện)</h3>
            </div>
            <div className="text-sm text-slate-500 bg-slate-200/50 px-3 py-1 rounded-full">
              Tự động sắp xếp theo mức độ ưu tiên
            </div>
          </div>
          <div className="divide-y divide-slate-100">
            {sector.scenarios.map((scenario, idx) => {
              
              const flowMap = { 'docs': 'docFlow', 'data': 'dataFlow', 'reports': 'mapFlow' };
              const currentFlowState = workflowState[flowMap[sectorId]];
              
              if ((sectorId === 'docs' && scenario.id === 'hc1') || 
                  (sectorId === 'data' && scenario.id === 'dl1') || 
                  (sectorId === 'reports' && scenario.id === 'pa1')) {
                if (currentFlowState === 'resolved') {
                  return (
                    <div key={scenario.id} className="p-5 flex items-center justify-between opacity-50 bg-green-50">
                      <div className="flex items-center gap-3">
                        <CheckCircle2 className="text-green-500" size={24}/>
                        <span className="text-sm font-bold text-green-700 line-through">{scenario.title}</span>
                      </div>
                      <span className="text-xs text-green-600 font-medium">Đã hoàn thành qua G-OS</span>
                    </div>
                  )
                }
              }

              return (
              <div key={scenario.id} className="p-5 hover:bg-slate-50 transition-colors flex items-start justify-between group">
                <div className="flex-1 pr-6">
                   <div className="flex items-center gap-3 mb-2">
                     <span className={`px-2 py-0.5 text-xs font-bold rounded ${idx < 2 ? 'bg-red-100 text-red-600 border border-red-200' : 'bg-amber-100 text-amber-600 border border-amber-200'}`}>
                       {idx < 2 ? 'KHẨN CẤP' : 'CẦN XỬ LÝ'}
                     </span>
                     <span className="text-base font-bold text-slate-800">{scenario.title}</span>
                   </div>
                   <p className="text-sm text-slate-500 flex items-center gap-1 mb-3"><MapPin size={14}/> Vị trí/Đối tượng: <strong>{scenario.location}</strong></p>
                   <div className="bg-blue-50 border border-blue-100 p-4 rounded-lg flex gap-3 items-start">
                     <Bot className="text-blue-500 shrink-0" size={18}/>
                     <div>
                       <p className="text-xs font-semibold text-blue-700 mb-1 uppercase tracking-wide">AI Phân tích & Gợi ý ban đầu:</p>
                       <p className="text-sm text-slate-700 leading-relaxed">{scenario.aiSuggest}</p>
                     </div>
                   </div>
                </div>
                <div className="shrink-0 flex flex-col items-end gap-3 border-l border-slate-200 pl-6 w-56 pt-2">
                   <div className="flex flex-col items-end w-full">
                     <span className="text-xs text-slate-500 uppercase tracking-wide font-medium mb-1">Phân công đề xuất:</span>
                     <span className="text-sm font-bold text-slate-700 text-right bg-slate-100 px-3 py-1.5 rounded-lg w-full text-center border border-slate-200">{scenario.assignee}</span>
                   </div>
                   <button 
                     onClick={() => navigate('detail', { 
                       type: sectorId, 
                       title: scenario.title, 
                       data: scenario 
                     })}
                     className="mt-2 w-full bg-slate-800 hover:bg-orange-600 text-white px-4 py-2.5 rounded-lg text-sm font-semibold transition-colors flex items-center justify-center gap-2 shadow-sm"
                   >
                     Xem & Ra Lệnh G-OS <ChevronRight size={16}/>
                   </button>
                </div>
              </div>
            )})}
          </div>
        </div>
      </div>
    );
  };

  const renderMapScreen = () => (
    <div className="space-y-6 animate-in fade-in slide-in-from-bottom-4 duration-500 h-full flex flex-col">
       <h2 className="text-2xl font-bold text-slate-800">Bản đồ số địa bàn</h2>
       <div className="bg-slate-200 rounded-xl border border-slate-300 shadow-sm flex-1 relative min-h-[500px] overflow-hidden">
          <div className="absolute inset-0 bg-[url('https://api.mapbox.com/styles/v1/mapbox/light-v11/static/105.59,21.31,14/1000x600?access_token=pk.eyJ1IjoiZGVtbyIsImEiOiJjbGo3eWxyOXEwMGF1M2RtcGNtMHl6dGFuIn0.mock')] bg-cover bg-center opacity-70 mix-blend-multiply"></div>
          
          {workflowState.mapFlow !== 'resolved' ? (
            <div 
              onClick={() => navigate('detail', { type: 'reports', title: 'Điểm nóng rác thải tự phát gây ô nhiễm', data: SECTOR_DATA.reports.scenarios[0] })}
              className="absolute top-[40%] left-[50%] flex flex-col items-center cursor-pointer group"
            >
              <div className="bg-red-500 text-white p-2 rounded-full shadow-lg shadow-red-500/50 group-hover:scale-110 transition animate-pulse">
                <AlertTriangle size={20} />
              </div>
              <div className="mt-2 bg-white px-3 py-1 rounded shadow text-xs font-bold border border-red-200 text-red-600">
                Ô nhiễm rác thải - Tổ 3
              </div>
            </div>
          ) : (
            <div className="absolute top-[40%] left-[50%] flex flex-col items-center">
              <div className="bg-green-500 text-white p-2 rounded-full shadow-lg">
                <CheckCircle2 size={20} />
              </div>
              <div className="mt-2 bg-white px-3 py-1 rounded shadow text-xs font-bold border border-green-200 text-green-600">
                Đã dọn dẹp - Tổ 3
              </div>
            </div>
          )}

          <div className="absolute top-[20%] left-[30%] flex flex-col items-center">
              <div className="bg-blue-500 text-white p-2 rounded-full shadow-lg">
                <MapPin size={20} />
              </div>
          </div>
       </div>
    </div>
  );

  const renderDetail = () => {
    const itemData = activeDetail.data || {};
    const defaultAiSuggest = itemData.aiSuggest || "Chưa có đề xuất từ hệ thống. Cần phân tích sâu.";
    const defaultAssignee = itemData.assignee || "Phòng ban chuyên môn";

    return (
      <div className="space-y-6 animate-in fade-in slide-in-from-bottom-4 duration-500 max-w-4xl mx-auto">
        <div className="flex items-center gap-4 mb-6">
          <button onClick={() => navigate(activeDetail.type ? activeDetail.type : 'dashboard')} className="text-slate-400 hover:text-slate-700">
            <ChevronRight className="rotate-180" size={24} />
          </button>
          <h2 className="text-2xl font-bold text-slate-800">Chi tiết sự việc & Ra lệnh điều hành</h2>
        </div>

        <div className="bg-white rounded-xl border border-slate-200 shadow-lg overflow-hidden">
          <div className="p-6 border-b bg-slate-800">
             <div className="flex items-start justify-between">
                <div>
                   <span className="text-xs font-bold uppercase tracking-wider mb-2 inline-block text-amber-400 bg-amber-400/20 px-3 py-1 rounded-full border border-amber-400/30">
                     Vấn đề cần xử lý cấp bách
                   </span>
                   <h3 className="text-2xl font-bold text-white mt-1">{activeDetail.title}</h3>
                   <p className="text-slate-300 flex items-center gap-2 mt-3 text-sm">
                     <MapPin size={16}/> Vị trí/Khu vực: <strong className="text-white">{itemData.location || 'Không rõ'}</strong>
                   </p>
                </div>
             </div>
          </div>
          
          <div className="p-8">
            <div className="flex justify-between items-center mb-4">
               <h4 className="font-semibold text-slate-800 text-lg flex items-center gap-2"><Bot className="text-blue-600"/> Phân tích & Gợi ý từ AI Hệ thống</h4>
               <button 
                  onClick={handleAnalyzeDetail}
                  disabled={isAnalysisLoading}
                  className="text-xs bg-purple-100 text-purple-700 px-4 py-2 rounded-lg font-bold hover:bg-purple-200 transition flex items-center gap-2 shadow-sm"
               >
                  {isAnalysisLoading ? <Loader2 size={16} className="animate-spin" /> : <Sparkles size={16} />}
                  Phân tích chuyên sâu với Gemini
               </button>
            </div>

            <div className="bg-blue-50/50 p-6 rounded-xl border border-blue-100 mb-8 shadow-inner">
              {aiAnalysis ? (
                <div className="whitespace-pre-wrap text-sm text-slate-700 leading-relaxed">
                   <div className="flex items-center gap-2 font-bold mb-3 text-purple-800">
                      <Sparkles size={18}/> Đánh giá từ Gemini AI (Thời gian thực):
                   </div>
                   {aiAnalysis}
                </div>
              ) : (
                <div className="text-sm text-slate-700 leading-relaxed border-l-4 border-blue-400 pl-4">
                  <p className="font-semibold text-slate-800 mb-2">Nhận định ban đầu:</p>
                  <p>{defaultAiSuggest}</p>
                </div>
              )}
            </div>

            <div className="bg-slate-50 p-6 rounded-xl border border-slate-200 flex items-center justify-between shadow-sm">
              <div>
                <h4 className="font-bold text-slate-800 text-lg">Chuyển thành Lệnh Hành động</h4>
                <p className="text-sm text-slate-500 mt-1">Đề xuất giao cho: <strong>{defaultAssignee}</strong></p>
              </div>
              <button 
                onClick={() => createTask(activeDetail.type, { title: `${activeDetail.title}`, assignee: defaultAssignee })}
                className="bg-orange-600 hover:bg-orange-700 text-white px-8 py-3.5 rounded-xl font-bold flex items-center gap-2 transition shadow-lg shadow-orange-600/30 hover:scale-105"
              >
                <Target size={20} /> Tạo nhiệm vụ G-OS ngay
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderGOSTasks = () => (
    <div className="space-y-6 animate-in fade-in slide-in-from-bottom-4 duration-500">
       <div className="flex justify-between items-center border-b border-slate-200 pb-4">
          <div>
            <h2 className="text-2xl font-bold text-slate-800 flex items-center gap-2">
              <Activity className="text-orange-600" /> Điều hành Công việc (G-OS)
            </h2>
            <p className="text-slate-500 text-sm">Hệ thống chuyển đổi từ Tình hình (IOC) sang Hành động.</p>
          </div>
       </div>

       <div className="grid gap-4">
         {tasks.map(task => (
           <div key={task.id} className="bg-white border border-slate-200 rounded-xl p-5 shadow-sm flex items-center justify-between hover:border-orange-300 transition">
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 bg-slate-100 rounded-lg flex items-center justify-center font-bold text-slate-400">
                  {task.id.split('-')[2] || task.id.split('-')[1]}
                </div>
                <div>
                  <h4 className="text-lg font-bold text-slate-800 mb-1">{task.title}</h4>
                  <div className="flex items-center gap-4 text-sm text-slate-500">
                    <span className="flex items-center gap-1"><User size={14}/> {task.assignee}</span>
                    <span className="flex items-center gap-1"><Clock size={14}/> Hạn: {task.date}</span>
                    <StatusBadge status={task.status} />
                  </div>
                </div>
              </div>
              <button 
                onClick={() => navigate('gos_tracking', task)}
                className="text-orange-600 bg-orange-50 hover:bg-orange-100 px-4 py-2 rounded-lg font-medium text-sm transition"
              >
                Theo dõi tiến độ
              </button>
           </div>
         ))}
       </div>
    </div>
  );

  const renderGOSTracking = () => {
    const task = activeDetail;
    return (
      <div className="space-y-6 animate-in fade-in slide-in-from-bottom-4 duration-500 max-w-4xl mx-auto">
        <div className="flex items-center gap-4 mb-2">
          <button onClick={() => navigate('gos_tasks')} className="text-slate-400 hover:text-slate-700">
            <ChevronRight className="rotate-180" size={24} />
          </button>
          <h2 className="text-xl font-bold text-slate-800">Chi tiết Nhiệm vụ</h2>
        </div>

        <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-6">
          <div className="flex justify-between items-start mb-8 pb-6 border-b border-slate-100">
            <div>
              <h3 className="text-2xl font-bold text-slate-900 mb-2">{task.title}</h3>
              <div className="flex gap-4 text-sm text-slate-600">
                 <span>Mã NV: {task.id}</span>
                 <span>Phụ trách: <strong>{task.assignee}</strong></span>
              </div>
            </div>
            <StatusBadge status={task.status} />
          </div>

          <div className="relative pl-6 border-l-2 border-slate-100 space-y-8 mb-10">
             <div className="relative">
                <div className="absolute -left-[35px] bg-white p-1 rounded-full text-green-500">
                  <CheckCircle2 size={24} />
                </div>
                <h4 className="font-bold text-slate-800 text-sm">Hệ thống IOC phát hiện vấn đề</h4>
                <p className="text-xs text-slate-500 mt-1">Lúc 08:00 sáng nay</p>
             </div>
             <div className="relative">
                <div className="absolute -left-[35px] bg-white p-1 rounded-full text-green-500">
                  <CheckCircle2 size={24} />
                </div>
                <h4 className="font-bold text-slate-800 text-sm">Lãnh đạo giao việc trên G-OS</h4>
                <p className="text-xs text-slate-500 mt-1">Đã giao cho {task.assignee}</p>
             </div>
             <div className="relative">
                <div className={`absolute -left-[35px] bg-white p-1 rounded-full ${task.status === 'Done' ? 'text-green-500' : 'text-orange-500'}`}>
                  {task.status === 'Done' ? <CheckCircle2 size={24} /> : <PlayCircle size={24} />}
                </div>
                <h4 className="font-bold text-slate-800 text-sm">Cán bộ xử lý & Báo cáo kết quả</h4>
                {task.status === 'Done' ? (
                  <div className="mt-2 p-3 bg-slate-50 rounded border border-slate-200 text-sm">
                    <strong>Báo cáo:</strong> Đã xử lý dứt điểm theo đúng quy định. Đính kèm biên bản (nếu có).
                  </div>
                ) : (
                   <div className="mt-2 space-y-3">
                     <p className="text-xs text-slate-500">Đang chờ cập nhật...</p>
                     <div className="bg-purple-50 p-4 rounded-lg border border-purple-100">
                       <p className="text-xs text-purple-700 mb-2 font-bold flex items-center gap-1"><Sparkles size={14}/> Hỗ trợ Cán bộ (AI Assistant):</p>
                       {draftReport ? (
                          <div className="text-sm bg-white p-3 rounded border border-purple-200 text-slate-700 whitespace-pre-wrap shadow-sm">
                            {draftReport}
                          </div>
                       ) : (
                         <button 
                            onClick={() => handleDraftReport(task.title)}
                            disabled={isDrafting}
                            className="text-xs bg-white border border-purple-200 text-purple-700 px-4 py-2 rounded-lg hover:bg-purple-100 transition shadow-sm flex items-center gap-2 font-semibold"
                          >
                            {isDrafting ? <Loader2 size={16} className="animate-spin" /> : <Sparkles size={16} />}
                            Sinh dự thảo báo cáo hoàn thành
                          </button>
                       )}
                     </div>
                   </div>
                )}
             </div>
          </div>

          {task.status !== 'Done' && (
            <div className="bg-slate-50 p-5 rounded-lg border border-slate-200 flex justify-between items-center">
              <span className="text-sm font-medium text-slate-600">Công cụ giả lập luồng demo:</span>
              <button 
                onClick={() => resolveTask(task.id, task.sourceType)}
                className="bg-green-600 hover:bg-green-700 text-white px-6 py-2.5 rounded-lg font-bold flex items-center gap-2 transition shadow-md"
              >
                <CheckCircle2 size={18} /> Đánh dấu Hoàn thành (Báo cáo IOC)
              </button>
            </div>
          )}
        </div>
      </div>
    );
  };

  const renderAIAssistant = () => {
    if (!isAIOpen) return null;

    let aiGreeting = "Chào Lãnh đạo, đây là tóm tắt tình hình Phường Vĩnh Yên hôm nay:";
    let aiContent = [];
    if (workflowState.docFlow === 'alert') aiContent.push("⚠️ Dịch vụ công: Có hồ sơ đất đai nguy cơ quá hạn. Cần giao việc ngay.");
    if (workflowState.mapFlow === 'alert') aiContent.push("⚠️ Địa bàn: Người dân phản ánh điểm nóng rác thải tại Tổ 3.");

    return (
      <div className="fixed inset-0 z-50 flex justify-end">
        <div className="absolute inset-0 bg-slate-900/20 backdrop-blur-sm" onClick={() => setIsAIOpen(false)}></div>
        <div className="relative w-full max-w-md bg-white h-full shadow-2xl flex flex-col animate-in slide-in-from-right duration-300">
          <div className="bg-gradient-to-r from-indigo-900 to-purple-900 p-6 text-white flex justify-between items-center">
            <div className="flex items-center gap-3">
              <Bot size={28} className="text-purple-300" />
              <div>
                <h3 className="font-bold text-lg">AI Trợ lý Điều hành</h3>
                <p className="text-xs text-purple-200">G-OS Copilot</p>
              </div>
            </div>
            <button onClick={() => setIsAIOpen(false)} className="text-purple-300 hover:text-white">✕</button>
          </div>
          
          <div className="flex-1 p-6 overflow-y-auto bg-slate-50 space-y-6">
            <div className="flex gap-4">
              <div className="w-8 h-8 rounded-full bg-purple-100 flex-shrink-0 flex items-center justify-center text-purple-700">
                <Sparkles size={16} />
              </div>
              <div className="bg-white p-4 rounded-xl shadow-sm border border-slate-100 text-sm text-slate-700 space-y-3 flex-1 rounded-tl-none">
                <p className="font-medium text-slate-900">{aiGreeting}</p>
                <ul className="space-y-2">
                  {aiContent.map((text, i) => <li key={i} className="leading-relaxed border-b border-slate-50 pb-2 last:border-0">{text}</li>)}
                </ul>
              </div>
            </div>

            {chatHistory.map((msg, idx) => (
               <div key={idx} className={`flex gap-4 ${msg.role === 'user' ? 'flex-row-reverse' : ''}`}>
                 <div className={`w-8 h-8 rounded-full flex-shrink-0 flex items-center justify-center ${msg.role === 'user' ? 'bg-blue-100 text-blue-700' : 'bg-purple-100 text-purple-700'}`}>
                   {msg.role === 'user' ? <User size={16} /> : <Bot size={16} />}
                 </div>
                 <div className={`p-4 rounded-xl shadow-sm border text-sm flex-1 whitespace-pre-wrap ${msg.role === 'user' ? 'bg-blue-600 text-white rounded-tr-none border-blue-700' : 'bg-white text-slate-700 rounded-tl-none border-slate-100'}`}>
                   {msg.content}
                 </div>
               </div>
            ))}

            {isChatLoading && (
               <div className="flex gap-4">
                 <div className="w-8 h-8 rounded-full bg-purple-100 flex-shrink-0 flex items-center justify-center text-purple-700">
                   <Loader2 size={16} className="animate-spin" />
                 </div>
                 <div className="bg-white p-4 rounded-xl shadow-sm border border-slate-100 text-sm text-slate-500 rounded-tl-none">
                   AI đang suy nghĩ...
                 </div>
               </div>
            )}
            <div ref={chatEndRef} />
          </div>
          
          <div className="p-4 bg-white border-t border-slate-200 shrink-0">
            <div className="relative flex items-center gap-2">
              <input 
                type="text" 
                value={chatInput}
                onChange={(e) => setChatInput(e.target.value)}
                onKeyDown={(e) => e.key === 'Enter' && handleAskAI()}
                placeholder="Hỏi AI trợ lý..." 
                className="w-full bg-slate-100 border-none rounded-full px-4 py-3 text-sm focus:ring-2 focus:ring-purple-500 outline-none" 
              />
              <button 
                onClick={() => handleAskAI()}
                disabled={isChatLoading || !chatInput.trim()}
                className="p-3 bg-purple-600 hover:bg-purple-700 disabled:bg-slate-300 text-white rounded-full transition"
              >
                <Send size={18}/>
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const isFullScreen = currentScreen === 'login' || currentScreen === 'hub';
  const dynamicSectors = Object.keys(SECTOR_DATA);
  const placeholderScreens = ['settings', 'help'];

  return (
    <div className="min-h-screen bg-slate-50 flex font-sans text-slate-900">
      
      {isFullScreen ? (
        currentScreen === 'login' ? (
          <div className="flex-1">
            <div className="min-h-screen bg-[#0a0f24] relative flex items-center justify-center overflow-hidden font-sans">
              <div className="absolute inset-0 bg-[linear-gradient(rgba(56,189,248,0.04)_1px,transparent_1px),linear-gradient(90deg,rgba(56,189,248,0.04)_1px,transparent_1px)] bg-[size:40px_40px] pointer-events-none"></div>
              <div className="absolute bottom-0 left-0 w-full h-[60vh] bg-[url('https://images.unsplash.com/photo-1506905925346-21bda4d32df4?q=80&w=2070&auto=format&fit=crop')] bg-cover bg-bottom opacity-30 mix-blend-screen pointer-events-none" style={{ WebkitMaskImage: 'linear-gradient(to top, rgba(0,0,0,1), rgba(0,0,0,0))', maskImage: 'linear-gradient(to top, rgba(0,0,0,1), rgba(0,0,0,0))' }}></div>
              
              <div className="relative z-10 w-full max-w-md bg-white/95 backdrop-blur-xl border border-white/20 rounded-[2rem] shadow-[0_0_50px_rgba(0,0,0,0.5)] p-8 animate-in zoom-in-95 duration-500">
                <div className="text-center mb-8">
                  <div className="w-20 h-20 mx-auto mb-5 flex items-center justify-center drop-shadow-xl">
                    <img src="https://upload.wikimedia.org/wikipedia/commons/a/a3/Emblem_of_Vietnam.svg" alt="Quốc huy Việt Nam" className="w-full h-full object-contain" />
                  </div>
                  <h2 className="text-2xl font-extrabold text-slate-800 mb-1">Đăng nhập Hệ thống</h2>
                  <p className="text-slate-500 text-sm font-medium">Mô hình Vận hành số Phường Vĩnh Yên</p>
                </div>
                
                <div className="space-y-4">
                  <button onClick={() => handleLogin('Chủ tịch UBND Phường')} className="w-full flex items-center justify-between bg-slate-50 hover:bg-blue-50 border border-slate-200 hover:border-blue-300 p-4 rounded-xl text-left transition-all duration-300 group">
                    <div className="flex items-center gap-4">
                      <div className="w-10 h-10 rounded-full bg-blue-100 text-blue-600 flex items-center justify-center group-hover:scale-110 group-hover:bg-blue-600 group-hover:text-white transition-all">
                        <User size={20}/>
                      </div>
                      <div>
                        <p className="text-slate-800 font-bold group-hover:text-blue-700">Lãnh đạo Phường</p>
                        <p className="text-xs text-slate-500 mt-0.5">Góc nhìn tổng quan, ra quyết định</p>
                      </div>
                    </div>
                    <ChevronRight className="text-slate-400 group-hover:text-blue-600" />
                  </button>

                  <button onClick={() => handleLogin('Trưởng bộ phận Một cửa')} className="w-full flex items-center justify-between bg-slate-50 hover:bg-amber-50 border border-slate-200 hover:border-amber-300 p-4 rounded-xl text-left transition-all duration-300 group">
                    <div className="flex items-center gap-4">
                      <div className="w-10 h-10 rounded-full bg-amber-100 text-amber-600 flex items-center justify-center group-hover:scale-110 group-hover:bg-amber-500 group-hover:text-white transition-all">
                        <Briefcase size={20}/>
                      </div>
                      <div>
                        <p className="text-slate-800 font-bold group-hover:text-amber-700">Trưởng bộ phận / Khối</p>
                        <p className="text-xs text-slate-500 mt-0.5">Góc nhìn chuyên đề, điều phối G-OS</p>
                      </div>
                    </div>
                    <ChevronRight className="text-slate-400 group-hover:text-amber-600" />
                  </button>

                  <button onClick={() => handleLogin('Cán bộ thực thi')} className="w-full flex items-center justify-between bg-slate-50 hover:bg-emerald-50 border border-slate-200 hover:border-emerald-300 p-4 rounded-xl text-left transition-all duration-300 group">
                    <div className="flex items-center gap-4">
                      <div className="w-10 h-10 rounded-full bg-emerald-100 text-emerald-600 flex items-center justify-center group-hover:scale-110 group-hover:bg-emerald-500 group-hover:text-white transition-all">
                        <HardHat size={20}/>
                      </div>
                      <div>
                        <p className="text-slate-800 font-bold group-hover:text-emerald-700">Cán bộ thực thi</p>
                        <p className="text-xs text-slate-500 mt-0.5">Góc nhìn hiện trường, báo cáo tiến độ</p>
                      </div>
                    </div>
                    <ChevronRight className="text-slate-400 group-hover:text-emerald-600" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        ) : (
          renderHub()
        )
      ) : (
        <>
          <aside className="w-72 bg-slate-900 text-slate-300 flex flex-col shadow-xl z-20 h-screen hidden md:flex shrink-0">
            <div className="p-6 shrink-0 border-b border-slate-800/80 mb-2">
              <h1 className="text-2xl font-black flex items-center gap-3 tracking-tight">
                <img src="https://upload.wikimedia.org/wikipedia/commons/a/a3/Emblem_of_Vietnam.svg" alt="Quốc huy" className="w-10 h-10 drop-shadow-md" />
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-300 to-orange-500 drop-shadow-sm">
                  G-OS Platform
                </span>
              </h1>
              <p className="text-xs text-slate-400 mt-2 ml-14 font-medium tracking-wide uppercase">Module: Phường Vĩnh Yên</p>
            </div>

            <div className="flex-1 px-4 py-2 overflow-y-auto custom-scrollbar">
              <div className="space-y-1 mb-6">
                <SidebarItem icon={Activity} label="Cổng Trung tâm" screenId="hub" isActive={currentScreen === 'hub'} />
                <SidebarItem icon={LayoutDashboard} label="Nhiệm vụ trọng tâm" screenId="dashboard" isActive={currentScreen === 'dashboard'} />
              </div>

              <div className="mb-6">
                <div 
                  className="flex items-center justify-between px-4 py-2.5 cursor-pointer rounded-lg text-slate-400 hover:bg-slate-800 hover:text-slate-200 transition-colors mb-1"
                  onClick={() => setIsNganhOpen(!isNganhOpen)}
                >
                  <div className="flex items-center gap-3">
                    <Layers size={18} />
                    <span className="font-medium text-sm">Ngành / Lĩnh vực</span>
                  </div>
                  {isNganhOpen ? <ChevronDown size={16} /> : <ChevronRight size={16} />}
                </div>
                
                {isNganhOpen && (
                  <div className="ml-4 border-l border-slate-700/50 mt-1 space-y-1">
                    <SidebarItem isSubItem icon={FileText} label="Hành chính công" screenId="docs" isActive={currentScreen === 'docs'} />
                    <SidebarItem isSubItem icon={HardHat} label="Xây dựng đô thị" screenId="construction" isActive={currentScreen === 'construction'} />
                    <SidebarItem isSubItem icon={TreePine} label="Tài nguyên môi trường" screenId="env" isActive={currentScreen === 'env'} />
                    <SidebarItem isSubItem icon={ShieldAlert} label="An ninh trật tự - ATGT" screenId="security" isActive={currentScreen === 'security'} />
                    <SidebarItem isSubItem icon={Briefcase} label="Doanh nghiệp & TM" screenId="business" isActive={currentScreen === 'business'} />
                    <SidebarItem isSubItem icon={GraduationCap} label="Giáo dục" screenId="education" isActive={currentScreen === 'education'} />
                    <SidebarItem isSubItem icon={HeartPulse} label="Y tế" screenId="health" isActive={currentScreen === 'health'} />
                    <SidebarItem isSubItem icon={Landmark} label="Kinh tế - Xã hội" screenId="economy" isActive={currentScreen === 'economy'} />
                  </div>
                )}
              </div>

              <div className="space-y-1 mb-6">
                <SidebarItem icon={AlertTriangle} label="Cảnh báo cần xử lý" screenId="alerts" isActive={currentScreen === 'alerts'} />
                <SidebarItem icon={Megaphone} label="Phản ánh hiện trường" screenId="reports" isActive={currentScreen === 'reports'} />
                <SidebarItem icon={Database} label="Dữ liệu & Số hoá" screenId="data" isActive={currentScreen === 'data'} />
                <SidebarItem icon={MapIcon} label="Bản đồ số địa bàn" screenId="map" isActive={currentScreen === 'map'} />
              </div>

              <div className="pt-4 border-t border-slate-800/80 space-y-1">
                <SidebarItem icon={Settings} label="Quản trị" screenId="settings" isActive={currentScreen === 'settings'} />
                <SidebarItem icon={BookOpen} label="Hướng dẫn sử dụng" screenId="help" isActive={currentScreen === 'help'} />
              </div>
            </div>

            <div className="p-4 border-t border-slate-800 shrink-0">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-slate-700 flex items-center justify-center"><User size={20}/></div>
                  <div>
                    <p className="text-sm font-bold text-white">{role || 'Quản trị viên'}</p>
                    <p className="text-xs text-slate-400">Đang hoạt động</p>
                  </div>
                </div>
                <button onClick={() => navigate('login')} className="text-slate-400 hover:text-white transition" title="Đăng xuất">
                  <LogOut size={18} />
                </button>
              </div>
            </div>
          </aside>

          <main className="flex-1 flex flex-col h-screen overflow-hidden relative">
            <header className="bg-white h-16 border-b border-slate-200 flex items-center justify-between px-8 shrink-0 z-10">
              <div className="flex items-center gap-2 text-sm text-slate-500 font-medium">
                {currentScreen === 'dashboard' && 'Tổng quan / Nhiệm vụ trọng tâm'}
                {dynamicSectors.includes(currentScreen) && `Ngành Lĩnh vực / ${SECTOR_DATA[currentScreen]?.title}`}
                {currentScreen === 'alerts' && 'Cảnh báo cần xử lý'}
                {currentScreen === 'reports' && 'Phản ánh hiện trường'}
                {currentScreen === 'data' && 'Dữ liệu & Số hoá'}
                {currentScreen === 'map' && 'Bản đồ số địa bàn'}
                {currentScreen === 'settings' && 'Quản trị'}
                {currentScreen === 'help' && 'Hướng dẫn sử dụng'}
                {currentScreen === 'detail' && 'IOC / Chi tiết Cảnh báo & Giao việc'}
                {(currentScreen === 'gos_tasks' || currentScreen === 'gos_tracking') && 'G-OS / Quản lý Nhiệm vụ'}
              </div>
              <div className="flex items-center gap-4">
                <button className="relative p-2 text-slate-400 hover:text-slate-600 transition">
                  <Bell size={20} />
                  {(workflowState.docFlow === 'alert' || workflowState.dataFlow === 'alert') && (
                    <span className="absolute top-1.5 right-1.5 w-2 h-2 bg-red-500 rounded-full animate-ping"></span>
                  )}
                </button>
                <button 
                  onClick={() => setIsAIOpen(true)}
                  className="bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 text-white px-4 py-2 rounded-full font-medium text-sm flex items-center gap-2 shadow-sm transition transform hover:scale-105"
                >
                  <Sparkles size={16} /> AI Trợ lý
                </button>
              </div>
            </header>

            <div className="flex-1 overflow-auto p-8 bg-slate-50/50">
              <div className="max-w-6xl mx-auto h-full">
                {currentScreen === 'dashboard' && renderDashboard()}
                {dynamicSectors.includes(currentScreen) && renderSectorDashboard(currentScreen)}
                {currentScreen === 'map' && renderMapScreen()}
                {currentScreen === 'detail' && activeDetail && renderDetail()}
                {currentScreen === 'gos_tasks' && renderGOSTasks()}
                {currentScreen === 'gos_tracking' && activeDetail && renderGOSTracking()}
                
                {placeholderScreens.includes(currentScreen) && (
                  <div className="flex-1 flex items-center justify-center bg-white flex-col h-full rounded-2xl border border-slate-200 shadow-sm animate-in fade-in duration-500">
                    <Settings size={64} className="text-slate-300 mb-4 animate-[spin_10s_linear_infinite]"/>
                    <h2 className="text-xl font-bold text-slate-500">Màn hình đang được xây dựng</h2>
                    <p className="text-slate-400 mt-2 text-sm text-center max-w-md">Chức năng này sẽ được cập nhật trong phiên bản tiếp theo của Prototype.</p>
                    <button onClick={() => navigate('dashboard')} className="mt-6 text-blue-600 hover:underline font-medium text-sm">Quay lại Tổng quan</button>
                  </div>
                )}
              </div>
            </div>

            {renderAIAssistant()}
            
            <style dangerouslySetInnerHTML={{__html: `
              .custom-scrollbar::-webkit-scrollbar { width: 6px; }
              .custom-scrollbar::-webkit-scrollbar-track { background: transparent; }
              .custom-scrollbar::-webkit-scrollbar-thumb { background: #334155; border-radius: 10px; }
              .custom-scrollbar::-webkit-scrollbar-thumb:hover { background: #475569; }
              
              @keyframes breath {
                0%, 100% { transform: scale(1); }
                50% { transform: scale(1.08); }
              }
              .animate-breath { animation: breath 25s infinite ease-in-out; }
        
              @keyframes float {
                0%, 100% { transform: translateY(0px); }
                50% { transform: translateY(-15px); }
              }
              .animate-float { animation: float 6s infinite ease-in-out; }
              
              @keyframes particleFloat {
                0%, 100% { transform: translateY(0) translateX(0); opacity: 0.2; }
                50% { transform: translateY(-20px) translateX(10px); opacity: 0.8; }
              }
            `}} />
          </main>
        </>
      )}
    </div>
  );
}


